// src/pages/About.jsx (replace the file with this)

import React, { useEffect, useRef, useState } from "react";
import AboutImg1 from "../images/about-us-image-1.jpg"; // adjust if needed
import AboutImg2 from "../images/about-us-video-image.jpg";
import "./css/aboutus.css";
import TestimonialSection from "../components/AboutUsTestimonialSection";

/* ---------- hooks ---------- */
function useInView(options = { threshold: 0.35 }) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (!ref.current) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setInView(true);
      },
      options
    );
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, [options]);

  return [ref, inView];
}

function useCountUp({ end, start, duration = 1800 }) {
  const [val, setVal] = useState(0);
  const hasRun = useRef(false);

  useEffect(() => {
    if (!start || hasRun.current) return;
    hasRun.current = true;

    let startTime = null;
    const step = (ts) => {
      if (startTime === null) startTime = ts;
      const p = Math.min((ts - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
      setVal(Math.round(end * eased));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [start, end, duration]);

  return val;
}

/* ---------- small component ---------- */
function Stat({ label, target, start }) {
  const value = useCountUp({ end: target, start });
  return (
    <div className="ass-stat">
      <div className="ass-number">{value}</div>
      <div className="ass-label">{label}</div>
    </div>
  );
}

/* ---------- page ---------- */
const About = () => {
  const [statsRef, statsInView] = useInView({ threshold: 0.4 });

  // banner image used in the counters/services slice
  const image = AboutImg2

  return (
    <div id="about-us-page">
      {/* Hero / intro */}
      <section className="banner">
        <div className="banner-image-container">
          <img src={AboutImg1} alt="Handyman" className="banner-image" />
        </div>

        <div className="about-banner-text">
          <div className="first-content">
            <p className="sub-heading">Our journey</p>
            <h2 className="services-heading">Committed to Excellence</h2>
            <p>
              Our skilled team is dedicated to providing top-notch handyman
              services, ensuring every project reflects our commitment to quality
              and customer satisfaction.
            </p>
            <p>Let’s begin your project!</p>
          </div>

          <div className="second-content">
            <h4 className="blog-title">Where innovation meets craftsmanship</h4>
            <p>
              From minor repairs to extensive renovations, we enhance the comfort
              and functionality of your space, ensuring every task is completed to
              the highest standards. With a strong emphasis on integrity, we
              guarantee that our solutions are customized and efficient.
            </p>
          </div>
        </div>
      </section>

      {/* Testimonials */}
   
        <TestimonialSection />
      
       <figure className="ass-hero">
          <img
            src={image}
            alt="Completed residential project"
            loading="lazy"
          />
        </figure>

         {/* Counters (animate when scrolled into view) */}
        <div className="ass-stats" ref={statsRef}>
          <Stat label="Projects completed" target={22} start={statsInView} />
          <Stat label="Satisfied clients" target={53} start={statsInView} />
          <Stat label="Years of service" target={9} start={statsInView} />
          <Stat label="Issues addressed" target={88} start={statsInView} />
        </div>

      {/* Counters + Services slice */}
      <section className="ass-wrap">
        {/* Banner image */}
       

       

        {/* Services grid */}
        <div className="ass-services">
          <div className="ass-intro">
            <p className="sub-heading">Tailored service offerings</p>
            <h3 className="services-heading">Select the perfect plan for you</h3>
            <p className="ass-desc">
              Choose from flexible service packages designed to match your needs.
              Whether a quick one-off fix or a larger renovation, our experts
              deliver craftsmanship and reliability.
            </p>
            <button className="ass-btn" type="button">
              Discover
            </button>
          </div>

          <div className="ass-grid">
            <div className="ass-card">
              <div className="ass-icon" aria-hidden>
                🧰
              </div>
              <h4 >Handyman services</h4>
              <p>Everyday repairs, fixtures, and punch-list jobs—done right.</p>
            </div>

            <div className="ass-card">
              <div className="ass-icon" aria-hidden>
                🏠
              </div>
              <h4>Enhancing space</h4>
              <p>Upgrades that add value: tiling, flooring, cabinetry, and more.</p>
            </div>

            <div className="ass-card">
              <div className="ass-icon" aria-hidden>
                ⚙️
              </div>
              <h4>Special services</h4>
              <p>Custom requests, renovations, and finishes with attention to detail.</p>
            </div>

            <div className="ass-card">
              <div className="ass-icon" aria-hidden>
                🛠️
              </div>
              <h4>Craft solutions</h4>
              <p>Unique builds and bespoke woodwork to fit your style.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
